<section class="faq" role="main">
  <header class="faq__header">
    <h1 class="faq__title" tabindex="0">{{ 'FAQ.TITLE' | translate }}</h1>
    <p class="faq__subtitle" tabindex="0">
      {{ 'FAQ.SUBTITLE' | translate }}
    </p>
  </header>

  <div class="faq__list">
    <article
      class="faq__item"
      *ngFor="let faq of faqs; trackBy: trackById"
      [class.is-open]="faq.isOpen"
    >
      <button
        class="faq__question"
        type="button"
        (click)="toggle(faq.id)"
        [attr.aria-expanded]="faq.isOpen"
        [attr.aria-controls]="'faq-answer-' + faq.id"
      >
        <span>{{ faq.question }}</span>
        <svg class="faq__icon" width="20" height="20" viewBox="0 0 24 24">
          <path
            d="M12 5v14M5 12h14"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
      </button>

      <div 
        class="faq__answer" 
        *ngIf="faq.isOpen" 
        [id]="'faq-answer-' + faq.id"
        role="region"
      >
        <ul class="faq__answer-list">
          <li class="faq__answer-item" *ngFor="let answer of faq.answers" tabindex="0">
            {{ answer }}
          </li>
        </ul>
      </div>
    </article>
  </div>
</section>